import React, {useState, useEffect} from "react";
import {useFormik} from "formik";
import {connect} from "react-redux";
// eslint-disable-next-line no-restricted-imports
import {green, red} from '@material-ui/core/colors';
import {CheckCircleOutlineRounded, HighlightOffRounded} from '@material-ui/icons';
import {Link} from "react-router-dom";
import * as Yup from "yup";
import {Form, InputGroup, Button} from 'react-bootstrap';
import {actions} from "../../../../redux/modules/auth/actions";
import {onlyNum} from "../../../../utils/formHelpers";
import {sendMobileCert, validMobileCert, findId} from "../../../../redux/modules/auth/crud";

import styles from './styles.module.scss';

const initialValues = {
  bsnLicNum: "",
  telNo: "",
  authNo: "",
};

let interval;

function ConvertTimer(num) {
  const value = `0${parseInt(num / 60)}`.slice(-2);
  const remainder = `0${num % 60}`.slice(-2);
  return `${value}:${remainder}`;
}

function ForgotId({ history }) {
  const [isRequested, setIsRequested] = useState(false);
  const [isValid, setValid] = useState(false);
  const [errMessage, setErr] = useState('');
  const [isFound, setFound] = useState(false);
  const [userId, setUserId] = useState(false);
  const [remain, setRemain] = useState(0);

  const ForgotIdSchema = Yup.object().shape({
    bsnLicNum: Yup
      .number()
      .typeError("숫자만 입력 가능합니다.")
      .required("사업자 등록번호를 입력하세요."),
    telNo: Yup
      .number()
      .typeError("숫자만 입력 가능합니다.")
      .required("전화번호를 입렭하세요."),
    authNo: Yup
      .number()
      .typeError("숫자만 입력 가능합니다."),
  });

  const getInputClasses = (fieldname, subCondition = true) => {
    if (form.touched[fieldname] && form.errors[fieldname]) {
      return "is-invalid";
    }
    if (form.touched[fieldname] && !form.errors[fieldname] && subCondition) {
      return "is-valid";
    }
    return "";
  };

  const handleSendCert = () => {
    const {telNo} = form.values;
    sendMobileCert(telNo).then(() => {
      setIsRequested(true);
      setRemain(180);
    }).catch(error => {
      alert(error.message);
    });
  };

  const handleValidCert = () => {
    const {authNo, telNo} = form.values;
    validMobileCert({authNo, telNo}).then(() => {
      setValid(true);
      clearTimeout(interval);
      form.setFieldTouched('authNo', true);
    }).catch(err => {
      alert(err.message);
    });
  };

  const form = useFormik({
    initialValues,
    validationSchema: ForgotIdSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      const { authNo, bsnLicNum, telNo } = form.values;
      findId({ authNo, bsnLicNum, telNo })
        .then((response) => {
          const {adminId} = response;
          setFound(true);
          setUserId(adminId);
        })
        .catch((err) => {
          const code = err.code.slice(-3);
          setSubmitting(false);
          setFound(true);
          if (code !== '400') {
            setErr(err.message);
          }
        });
    },
  });

  useEffect(() => {
    if (!remain) return clearTimeout(interval);
    interval = setTimeout(() => setRemain(remain - 1), 1000);
    return () => clearTimeout(interval);
  }, [remain]);

  return (
    <div className="login-form login-forgot" style={{display: "block"}}>

      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">아이디 찾기</h3>
        <div className="text-muted font-weight-bold">
          아직 계정이 없으신가요 ? 여기서
          <Link className="font-weight-bold ml-2" to="/registration">계정을 생성</Link>
          하세요.
        </div>
      </div>
      {/* end::Head */}

      <Form
        id="forgot-id-form"
        className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
        onSubmit={form.handleSubmit}
      >
        {form.status && (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">
              {form.status}
            </div>
          </div>
        )}

        {/* begin: bsnLicNum */}
        <Form.Group controlId="businessNo">
          <Form.Label>
            <span className="text-danger mr-2 align-middle">*</span>
            <span className="font-weight-boldest">사업자 등록번호</span>
          </Form.Label>
          <Form.Control
            placeholder="- 없이 입력"
            type="text"
            name="bsnLicNum"
            maxLength={10}
            className={`form-control h-auto py-5 px-6 ${getInputClasses("bsnLicNum")}`}
            {...form.getFieldProps("bsnLicNum")}
          />
          {form.touched.bsnLicNum && form.errors.bsnLicNum ? (
            <div className="fv-plugins-message-container">
              <Form.Text className="fv-help-block">{form.errors.bsnLicNum}</Form.Text>
            </div>
          ) : (
            <Form.Text className="text-muted">
              사업자번호를 입력 후 확인 버튼을 눌러 확인을 완료해주세요.
            </Form.Text>
          )}
        </Form.Group>
        {/* end: businessNo */}

        {/* begin: Mobile */}
        <Form.Group controlId="mobile">
          <Form.Label>
            <span className="text-danger mr-2 align-middle">*</span>
            <span className="font-weight-boldest">전화번호</span>
          </Form.Label>
          <InputGroup className="mb-2 mr-sm-2">
            <Form.Control
              placeholder="- 없이 입력"
              type="text"
              name="telNo"
              onKeyDown={onlyNum}
              className={`form-control h-auto py-5 px-6 ${getInputClasses("telNo", isValid)}`}
              {...form.getFieldProps("telNo")}
            />
            <InputGroup.Append>
              <Button
                type="button"
                variant="primary"
                className="w-120px font-weight-boldest font-size-h6"
                disabled={isValid || form.errors.telNo || !form.values.telNo}
                onClick={handleSendCert}
              >
                {isRequested ? '재 전송' : '인증번호 전송'}
              </Button>
            </InputGroup.Append>
          </InputGroup>
          {form.touched.telNo && form.errors.telNo ? (
            <div className="fv-plugins-message-container">
              <Form.Text className="fv-help-block">{form.errors.telNo}</Form.Text>
            </div>
          ) : (
            <Form.Text className="text-muted">
              인증번호 전송은 통신사에 따라 최대 1분까지 소요될 수 있습니다.<br/>
              인증번호가 도착하지 않을 경우 ‘재전송’을 눌러주세요.
            </Form.Text>
          )}
        </Form.Group>
        {/* end: Mobile */}

        {/* begin: Mobile Cert */}
        {isRequested && (
          <Form.Group controlId="mobileCert">
            <InputGroup className="mb-2 mr-sm-2">
              <Form.Control
                placeholder={remain === 0 ? "인증시간 만료" : "인증번호 입력"}
                type="text"
                name="authNo"
                onKeyDown={onlyNum}
                disabled={remain === 0}
                className={`form-control h-auto py-5 px-6 ${getInputClasses("authNo", isValid)}`}
                {...form.getFieldProps("authNo")}
              />
              {!isValid && (
                <span className={styles.timer}>
                  {ConvertTimer(remain)}
                </span>
              )}
              <InputGroup.Append>
                <Button
                  type="button"
                  variant="primary"
                  disabled={remain === 0 || isValid || form.values.authNo.length !== 6}
                  className="w-120px font-weight-boldest font-size-h6"
                  onClick={handleValidCert}
                >
                  인증
                </Button>
              </InputGroup.Append>
            </InputGroup>
            {form.touched.authNo && form.errors.authNo ? (
              <div className="fv-plugins-message-container">
                <Form.Text className="fv-help-block">{form.errors.authNo}</Form.Text>
              </div>
            ) : null}
          </Form.Group>
        )}
        {/* end: Mobile Cert */}

        <div className="my-5">
          {isFound && userId && (
            <p>
              <CheckCircleOutlineRounded fontSize="large" style={{color: green[500]}} className="mr-3"/>
              가입하신 ID는 <strong>{userId}</strong> 입니다.
            </p>
          )}
          {isFound && !userId && !errMessage && (
            <p>
              <HighlightOffRounded fontSize="large" style={{color: red[500]}} className="mr-3"/>
              입력하신 정보의 계정은 존재하지 않습니다. <br/>
              <span className="ml-12">새롭게 <Link to="/registration">계정을 생성</Link>하고 룰루를 이용해보세요.</span>
            </p>
          )}
          {isFound && errMessage && (
            <p>
              <HighlightOffRounded fontSize="large" style={{color: red[500]}} className="mr-3"/>
              {errMessage}
            </p>
          )}
        </div>

        <div className="form-group d-flex flex-wrap flex-center">
          <div className="w-50 px-4 my-3">
            <button
              type="button"
              className="btn btn-secondary font-weight-bold px-9 py-4 w-100"
              onClick={() => history.goBack()}
            >
              취소
            </button>
          </div>
          <div className="w-50 px-4 my-3">
            <button
              type="submit"
              disabled={!isValid}
              className="btn btn-primary font-weight-bold px-9 py-4 w-100"
            >
              <span>아이디 찾기</span>
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default connect(null, actions)(ForgotId);
